import React from "react"
import i18n from "i18n"
import { Grid, Typography } from "@mui/material"
import PropTypes from "prop-types"
import TextFieldNumber from "common/TextFieldNumber"
import TaxField from "components/ProfileRefinament/Taxes/TaxField"
import { useTaxes } from "components/ProfileRefinament/Taxes/hooks/useTaxes"

const AmountsSection = ({ formData, handleInputChange, readOnlyAmounts }) => {
  const { data = [] } = useTaxes(
    formData.organizationId,
    !!formData.organizationId,
  )
  const taxes = data.filter(t => t.type === "tax" && t.active)
  const retentions = data.filter(t => t.type === "retention" && t.active)

  return (
    <>
      <Grid item xs={12}>
        <Typography sx={{ mt: 2, fontWeight: "bold" }}>
          {i18n.t("costs.modal.amounts")}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextFieldNumber
          label={i18n.t("costs.columns.subtotal")}
          value={formData.subtotal}
          min={0}
          fixedDecimalScale
          onChange={value =>
            handleInputChange("subtotal")({ target: { value } })
          }
          suffix="€"
          allowNegative={false}
          readOnly={!!readOnlyAmounts}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TaxField
          label={i18n.t("costs.columns.taxes")}
          options={taxes}
          selectedTaxes={formData.tax || []}
          onChange={taxes =>
            handleInputChange("tax")({ target: { value: taxes } })
          }
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TaxField
          label={i18n.t("costs.columns.retentions")}
          options={retentions}
          selectedTaxes={formData.retention || []}
          onChange={retentions =>
            handleInputChange("retention")({ target: { value: retentions } })
          }
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextFieldNumber
          readOnly
          label={i18n.t("costs.columns.total")}
          fixedDecimalScale
          value={formData.total}
          suffix="€"
        />
      </Grid>
    </>
  )
}

AmountsSection.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  readOnlyAmounts: PropTypes.bool,
}

export default AmountsSection
